import * as React from 'react';

import CcmCampaignDetailsOverview from './overview/CcmCampaignDetailsOverview';
import CcmCampaignDetailsSpecifics from './specifics/CcmCampaignDetailsSpecifics';
import CcmCampaignDetailsOverviewCreatorless from './overview/CcmCampaignDetailsOverviewCreatorless';

import './ccm-campaign-details.scss';

import type { Campaign } from 'types';

type Props = {
  campaign: Campaign,
  hideSpecifics?: boolean
};

const CcmCampaignDetails: React.FC<Props> = ({
  campaign,
  hideSpecifics
}): JSX.Element => {
  const isCampaignCreatorless = campaign.campaignType === 'ccm_creatorless';

  return (
    <div className="ccm-campaign-details">
      <div className="ccm-campaign-details__overview">
        {
          isCampaignCreatorless ? (
            <CcmCampaignDetailsOverviewCreatorless
              campaign={campaign}
            />
          ) : (
            <CcmCampaignDetailsOverview
              campaign={campaign}
            />
          )
        }
      </div>
      {hideSpecifics || isCampaignCreatorless ? null : (
        <div className="ccm-campaign-details__specifics">
          <CcmCampaignDetailsSpecifics
            campaign={campaign}
          />
        </div>
      )}
    </div>
  );
};

export default CcmCampaignDetails;
